import styled from 'styled-components';
import { Displays, DisplaysValues } from '../type';

export const Eye = styled.div<{
  $displayMode: DisplaysValues;
}>`
  position: absolute;
  width: ${(props) =>
    props.$displayMode === Displays.LANDSCAPE ? '4vmin' : '6vmin'};
  height: ${(props) =>
    props.$displayMode === Displays.LANDSCAPE ? '4vmin' : '6vmin'};
  bottom: 0;
  margin-bottom: -1.5vmin;
  right: 0;
  margin-right: -1.5vmin;
  background: url(${process.env.PUBLIC_URL}/images/eye.webp) no-repeat;
  background-size: contain;
`;
